import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Button from 'UIKit/Button'
import Page from 'UIKit/Page'
import Text from 'UIKit/Text'
import AlchemyDisplayContent from 'components/AlchemyDisplayContent'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Icons } from 'svgs'

const AdditionalContent: React.FC<BoxProps & { htmlContent?: string }> = ({ htmlContent, ...props }) => {
  const { t } = useTranslation()
  const [isShowMore, setIsShowMore] = useState(true)

  useEffect(() => {
    setIsShowMore(true)
  }, [htmlContent])

  return (
    <StyledContainer {...props}>
      <StyledInnerContainer>
        <StyledContent $isShowMore={isShowMore}>
          <AlchemyDisplayContent my="16px" content={htmlContent} />
        </StyledContent>
        <StyledBlur $isShowMore={isShowMore}>
          <StyledButton
            onClick={() => {
              setIsShowMore(!isShowMore)
            }}
            mb="20px"
            height="32px"
            maxWidth="160px"
            width="100%"
            className="hunny-list-loadmore-btn"
            variant="secondary"
            style={{ background: 'rgba(255,255,255,0.05)' }}
            $isShowMore={isShowMore}
          >
            <Text fontSize="12px">{t(isShowMore ? 'Show more' : 'Show less')}</Text>
            <Icons.ArrowDownIcon />
          </StyledButton>
        </StyledBlur>
      </StyledInnerContainer>
    </StyledContainer>
  )
}

const StyledContainer = styled(Page)`
  padding-top: 20px;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
`

const StyledButton = styled(Button)<{ $isShowMore?: boolean }>`
  z-index: 1;
  svg {
    transform: ${({ $isShowMore }) => ($isShowMore ? 'rotate(0deg)' : 'rotate(180deg)')};
    transition: 0.2s;
  }
`

const StyledInnerContainer = styled(Page)`
  position: relative;
  background: rgb(25 29 37);
  padding: 20px;
  border-radius: 20px;
  overflow: hidden;
  height: 100%;
`

const StyledBlur = styled(Box)<{ $isShowMore?: boolean }>`
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 260px;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: flex-end;

  &:after {
    content: '';
    opacity: ${({ $isShowMore }) => ($isShowMore ? 1 : 0)};
    z-index: 0;
    background: linear-gradient(0deg, rgb(25 29 37 / 100%) 58px, rgb(25 29 37 / 65%) 40%, transparent 50%);
    position: absolute;
    bottom: 0px;
    left: 0px;
    height: 260px;
    width: 100%;
  }
`
const StyledContent = styled(Box)<{ $isShowMore?: boolean }>`
  max-height: ${({ $isShowMore }) => ($isShowMore ? '100px' : 'auto')};
  margin-bottom: 52px;
  & h1 {
    font-size: 24px;
  }

  & h2 {
    font-size: 22px;
  }
  & h3 {
    font-size: 20px;
  }
  & h4 {
    font-size: 18px;
  }
  & h5 {
    font-size: 16px;
  }
  & h6 {
    font-size: 14px;
  }

  & > * {
    color: ${({ theme }) => theme.colors.textSubtle};
  }
  & a {
    color: ${({ theme }) => theme.colors.info};
  }
`

export default AdditionalContent
